import { render, staticRenderFns } from "./Top-Admin-Dynamic-Group.vue?vue&type=template&id=4d7db7fa"
import script from "./Top-Admin-Dynamic-Group.vue?vue&type=script&lang=js"
export * from "./Top-Admin-Dynamic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports